import { useAuthCookiePersistence } from "hooks/useAuthCookiePersistence";
import Cookies from "js-cookie";
export { };

/*
    We're adding 'ReactNativeWebView' to the window object. This is provided by expo,
    and it allows us to post messages back to the app if this object is present.

    https://github.com/react-native-webview/react-native-webview/blob/master/docs/Guide.md
*/

declare global {
    interface Window {
        ReactNativeWebView: {
            postMessage(msg: string): void;
        }
    }
}

enum MobileMessage {
    AccountsUpdated = "AccountsUpdated",
    Cancelled = "Cancelled"
}

const CookieKeyInAppSource = "InApp.Source";

const useMobileMessages = () => {
    const { isInWebView } = useAuthCookiePersistence();
    const mobileApp = window.ReactNativeWebView;
    const appSource = Cookies.get(CookieKeyInAppSource) ?? "App";

    const isAvailable = isInWebView && mobileApp !== undefined;

    const accountsUpdated = () =>
        mobileApp?.postMessage(MobileMessage.AccountsUpdated);

    const actionCancelled = () =>
        mobileApp?.postMessage(MobileMessage.Cancelled);

    return {
        isAvailable,
        appSource,
        accountsUpdated,
        actionCancelled
    };
};

export default useMobileMessages;